
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  public advList1 = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            title: '优越位置',
            desc: '位于香港九龙塘核心地段，环境安全安静、生活便利。',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/k12_feature1.png'),
        },
        {
            id: 2,
            title: '贴心服务',
            desc: '为低龄学生提供全包式照顾，包括早餐晚餐、接送及清洁服务。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/k12_feature2.png'),
        },
        {
            id: 3,
            title: '多样房型',
            desc: '提供单人间、双人间、三人间多种住宿选择。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature3.png'),
        },
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            title: '優越位置',
            desc: '位於香港九龍塘核心地段，環境安全寧靜、生活便利',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/k12_feature1.png'),
        },
        {
            id: 2,
            title: '貼心服務',
            desc: '為低齡學生提供全包式照顧，包括早餐晚餐、接送及清潔服務。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/k12_feature2.png'),
        },
        {
            id: 3,
            title: '多樣房型',
            desc: '設有單人房、雙人房及三人房供選擇。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature3.png'),
        },
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            title: 'Prime Spot',
            desc: 'Prime location in Kowloon Tong – safe, quiet, and convenient.',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/k12_feature1.png'),
        },
        {
            id: 2,
            title: 'Full Care',
            desc: 'All-inclusive services for younger students with meals, transfers, and cleaning.',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/k12_feature2.png'),
        },
        {
            id: 3,
            title: 'Room Choice',
            desc: 'Room options include Single, Twin, or Triple.',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature3.png'),
        },
      ]
    }
  ];public advList2 = [
    {
      lang: 'zh',
      data: [
        {
            id: 4,
            title: '专属配置',
            desc: '每人配备独立床铺、衣柜、书桌与椅子。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature4.png'),
        },
        {
            id: 5,
            title: '独立卫浴',
            desc: '每间房设有独立卫浴，舒适私密。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/k12_feature5.png'),
        },
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 4,
            title: '專屬配置',
            desc: '每位學生均配備獨立床位、衣櫃、書桌與椅子。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature4.png'),
        },
        {
            id: 5,
            title: '獨立浴室',
            desc: '每間房設有獨立浴室，舒適私隱兼備。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/k12_feature5.png'),
        },
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 4,
            title: 'Private Set',
            desc: 'Each student enjoys a private bed, wardrobe, desk, and chair.',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/k12_feature4.png'),
        },
        {
            id: 5,
            title: 'En-Suite',
            desc: 'Every room features an en-suite bathroom for privacy and comfort.',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/k12_feature5.png'),
        },
      ]
    }
  ];
  public roomTypeList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            roomType: '单人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: '$19,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 独立入住，空间宽敞安静'},
                {id: 2, desc: '● 配备独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 房间设有独立浴室，私密舒适'},
                {id: 4, desc: '● 适合需要安静学习空间的学生'}
            ],
            img: require('@/assets/image/common/k12_room1.png'),
        },
        {
            id: 2,
            roomType: '双人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: '$16,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 独立入住，空间宽敞安静'},
                {id: 2, desc: '● 配备独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 房间设有独立浴室，私密舒适'},
                {id: 4, desc: '● 适合需要安静学习空间的学生'}
            ],
            img: require('@/assets/image/common/k12_room2.png'),
        },
        {
            id: 3,
            roomType: '三人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: '$18,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 独立入住，空间宽敞安静'},
                {id: 2, desc: '● 配备独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 房间设有独立浴室，私密舒适'},
                {id: 4, desc: '● 适合需要安静学习空间的学生'}
            ],
            img: require('@/assets/image/common/k12_room3.png'),
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            roomType: '單人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: 'HKD 19,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 独立入住，空间宽敞安静'},
                {id: 2, desc: '● 配备独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 房间设有独立浴室，私密舒适'},
                {id: 4, desc: '● 适合需要安静学习空间的学生'}
            ],
            img: require('@/assets/image/common/k12_room1.png'),
        },
        {
            id: 2,
            roomType: '雙人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: '$16,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 两人共享房间，舒适又具社交氛围'},
                {id: 2, desc: '● 每人拥有独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 配备独立浴室，整洁便利'},
                {id: 4, desc: '● 适合结伴学习的学生'}
            ],
            img: require('@/assets/image/common/k12_room2.png'),
        },
        {
            id: 3,
            roomType: '三人房',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: '$18,800起/每人',
            roomList : [],
            features: [
                {id: 1, desc: '● 三人共享房间，空间宽敞明亮'},
                {id: 2, desc: '● 每人配有独立床位、衣柜、书桌与椅子'},
                {id: 3, desc: '● 房间设有独立浴室，清洁舒适'},
                {id: 4, desc: '● 适合希望增加社交互动的学生'}
            ],
            img: require('@/assets/image/common/k12_room3.png'),
        }
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            roomType: 'Single',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: 'From $19,800/person',
            roomList : [],
            features: [
                {id: 1, desc: '● Private room for one student'},
                {id: 2, desc: '● Includes bed, wardrobe, desk, and chair'},
                {id: 3, desc: '● En-suite bathroom for full privacy'},
                {id: 4, desc: '● Ideal for students who prefer a quiet environment'}
            ],
            img: require('@/assets/image/common/k12_room1.png'),
        },
        {
            id: 2,
            roomType: 'Double',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: 'From $16,800/person',
            roomList : [],
            features: [
                {id: 1, desc: '● Shared by two students'},
                {id: 2, desc: '● Each student has an individual bed, wardrobe, desk, and chair'},
                {id: 3, desc: '● En-suite bathroom for comfort and convenience'},
                {id: 4, desc: '● Great for students who enjoy companionship'}
            ],
            img: require('@/assets/image/common/k12_room2.png'),
        },
        {
            id: 3,
            roomType: 'Triple',
            desc: '',
            roomSize: '',
            roomHeight: '',
            roomPeople: '',
            roomPrice: 'From $18,800/person',
            roomList : [],
            features: [
                {id: 1, desc: '● Shared by three students, bright and spacious'},
                {id: 2, desc: '● Each student has a private bed, wardrobe, desk, and chair'},
                {id: 3, desc: '● En-suite bathroom for hygiene and comfort'},
                {id: 4, desc: '● Ideal for students who enjoy group living and cultural exchange'}
            ],
            img: require('@/assets/image/common/k12_room3.png'),
        }
      ]
    }
  ]

  public locationList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            university: '港铁九龙塘站',
            time: '约10分钟',
        },
        {
            id: 2,
            university: '又一城',
            time: '约15分钟',
        },
        {
            id: 3,
            university: '香港城市大学',
            time: '约15分钟',
        },
        {
            id: 4,
            university: '旺角大球场',
            time: '乘坐公共交通约10分钟',
        },
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            university: '港鐵九龍塘站',
            time: '約10分鐘',
        },
        {
            id: 2,
            university: '又一城',
            time: '約15分鐘',
        },
        {
            id: 3,
            university: '香港城市大學',
            time: '約15分鐘',
        },
        {
            id: 4,
            university: '旺角大球場',
            time: '乘坐公共交通約10分鐘',
        },
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            university: 'Kowloon Tong MTR Station',
            time: 'About 10 minutes',
        },
        {
            id: 2,
            university: 'Festival Walk',
            time: 'About 15 minutes',
        },
        {
            id: 3,
            university: 'City University of Hong Kong',
            time: 'About 15 minutes',
        },
        {
            id: 4,
            university: 'Mong Kok Stadium',
            time: 'About 10 minutes  by public transport',
        },
        {
            id: 5,
            university: 'The University of Hong Kong',
            time: 'About 40 minutes',
        },
        {
            id: 6,
            university: 'The Chinese University of Hong Kong',
            time: 'About 50 minutes',
        },
        {
            id: 7,
            university: 'The Hong Kong University of Science and Technology',
            time: 'About 60 minutes',
        }
      ]
    }
  ]
  public locationDescList = [
    {
      lang: 'zh',
      desc1: '步行5分钟可达黄埔站（观塘线）、何文田站（观塘线）、红磡站（东铁线）',
      desc2: '交通方便，乘坐公共交通可轻松前往香港各主要地区。 ',
      desc3: ''
    },
    {
      lang: 'zh-hk',
      desc1: '步行5分鐘可達黃埔站（觀塘線）、何文田站（觀塘線）、紅磡站（東鐵線）',
      desc2: '交通方便，乘坐公共交通可輕鬆前往香港各主要地區。',
      desc3: ''
    },
    {
      lang: 'en-us',
      desc1: '5-minute walk to Whampoa Station (Kwun Tong Line), Ho Man Tin Station (Kwun Tong Line), Hung Hom Station (East Rail Line)',
      desc2: 'The apartment is directly opposite the bus stop, directly connected to major areas such as Mong Kok, Tsim Sha Tsui, Shatin, etc.',
      desc3: ''
    },
  ]

  public feeDescList = [];

  public contactInfo = [
    {
      lang: 'zh',
      address: '香港九龙塘渭州道10号',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    },
    {
      lang: 'zh-hk',
      address: '香港九龍塘渭州道10號',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    },
    {
      lang: 'en-us',
      address: '10 Wiltshire Road, Kowloon Tong',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    }
  ]
  public showRoomVisit = false;
  public roomList = [];
  public roomSelected = 0;
  public roomVideo = '';
  public userFirstName = '';
  public userLastName = '';
  public userPhone = '';
  public userEmail = '';
  public userQuestion = '';
  public errorMsg = '';
  public successMsg = '';
  public getAdvList1() {
    return this.advList1.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getAdvList2() {
    return this.advList2.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getRoomTypeList() {
    return this.roomTypeList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getLocationList() {
    return this.locationList.find((item: any)=>item.lang === AppModule.language)?.data;
  }
  public getLocationDescList() {
    return this.locationDescList.find((item: any)=>item.lang === AppModule.language);
  }
  public getFeeDescList() {
    if (this.feeDescList.length > 0) {
        return this.feeDescList.find((item: any)=>item.lang === AppModule.language);
    }
    return null;
  }
  public getContactInfo() {
    return this.contactInfo.find((item: any)=>item.lang === AppModule.language);
  }
  public goRoomVisit(item: any) {
    this.showRoomVisit = true;
    this.roomList = item.roomList;
  }
  public closeRoomVisit() {
    this.showRoomVisit = false;
  }
  public setRoomVideo(item: any) {
    this.roomVideo = item.videoUrl;
    this.roomSelected = item.id;
  }
}
